import { LearningMaterials } from "UIPalette/LearningMaterials/LearningMaterials";
import { useTranslation } from "react-i18next";

export type TrackerLearningMaterialsProps = {
  categoryIdsFilter: string[];
};

export const TrackerLearningMaterials = ({ categoryIdsFilter }: TrackerLearningMaterialsProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <h2>{t("wellbeing.usefulArticles.heading")}</h2>
      <LearningMaterials
        categoryIds={categoryIdsFilter}
        errorMessage={t("wellbeing.usefulArticles.error")}
        ariaLabel={t("wellbeing.usefulArticles.label")}
      />
    </div>
  );
};
